declare const pdfMake: any;
import { Injectable } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

import * as vspecData from '../../../shared/model/common/VSpecData';
import { ImageData } from '../../../shared/model/api/image-data';

import { SharedDataService } from '../../../core/services/shared-data.service';
import { SharedFunctionService } from '../../../core/services/shared-func.service';
import { ddImageDataService } from '../../../core/services/dd-image-data.service';
//
// Library
//
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';
import { AutorizationService } from 'src/app/core/services/authorization-service';
import { fonts } from '../meta-data/Fonts';

export interface PaymentPdfData {
    dealerDetails: any,
    carImage: ImageData,
    interiorColorImage: ImageData,
    exteriorColorImage: ImageData
}

@Injectable({
    providedIn: 'root'
})

export class PaymentSimulatorPdfService {
    borderColor = '#cccccc';
    backgroundColor = '#F2F3F7';
    private htmlRegEx = /(\[([^\]]+)\]|<([^>]+)>)/gi;
    public base64Data: any;
    dealDetails: any;
    filestring: string;
    dataGrid: any;
    marketingName: string;
    selectedRow: any;
    public currentRow: number = 0;
    public isDesking: boolean;
    public brand: string;
    leaseType: string = '';
    selectedLender: string='';
    highlightedIndex:number=0;
    fontFamilyHeading = 'toyota';
    grayColor = '#383838';
    constructor(private _currencyPipe: CurrencyPipe, private environment: EnvironmentConfiguration, private sharedDataService: SharedDataService, private imgaeDataService: ddImageDataService,
        private sharedFunctionService: SharedFunctionService, private autorizationService: AutorizationService) {
        this.isDesking = this.environment.DESKING && sharedDataService.isDesking;
        this.brand = this.autorizationService.brand;
        if(this.brand === 'Toyota') {
            this.fontFamilyHeading = 'toyotasemibold';
        } else {
            this.fontFamilyHeading = 'nobel';
        }
    }


    //
    // Write the pdf documents
    //
    public generatePdf(dealData): any {
        //
        // Set Custom Fonts
        //
        this.dealDetails = dealData
        pdfMake.vfs = vspecData.VSpecData.VSPEC_FONTS;
        
        //
        // Get Default Fonts
        //
        pdfMake.fonts = fonts;
        const contentSection: any[] = [];
        const vehicle = dealData[0]?.vehicle;
        const customer = dealData[0]?.customer;
        const content: any[] = [
            this.renderPaymentSimulationHeader(dealData),
            this.renderCustomerVehicleDetails(vehicle, customer),
            this.renderSimulatedFiguresHeading(),
            this.renderSimulatedFigures(dealData[0]),
            this.renderSpace(),
            dealData[0].paymentType.includes('cash') ? [] : this.renderHypoPaymentDetials(vehicle),
            this.renderSpace(),
            this.renderHypoPricing(dealData[0])
        ];
        contentSection.push(...content);
        //
        // Define the Document Definition
        //
        const documentDefinition = {
            pageSize: {
                height: 792,
                width: 612
            },
            styles: vspecData.VSpecData.VSPEC_STYLES,
            pageOrientation: 'portrait',
            defaultStyle: {
                font: 'toyota',
            },
            pageMargins: this.brand === 'Toyota' ? [12, 60, 10, 80] : [12, 70, 10, 80],
            background: [
                {
                    image: vspecData.VSpecData.example_bg.image,
                    height: 792,
                    width: 612,                    
                }
            ],
            header: {
                stack: [
                    this._renderHeader(dealData[0]),
                ],
                margin: [22, 18, 15, 0],
            },

            footer: (currentPage, pageCount)=> {
                return {
                    margin: [22, 0, 45, 0],
                    table: {
                        widths: ['*'],
                        body: [
                            [
                                { text: "Page " + currentPage.toString() + ' of ' + pageCount, alignment: 'left', fontSize: 10 },
                            ],
                            [
                                { text: [{ text: 'Created: '}, this.sharedFunctionService.formatDateWithSeperation(new Date().toLocaleDateString(), '/', null)], margin: [0, 0, 0, 0], fontSize: 10, alignment: 'left' }
                            ]
                        ]
                    },
                    layout: 'noBorders'
                };
            },
            content: [
                {
                    margin: [10, 0, 10, 0],
                    style: 'standardTable',
                    table: {
                        widths: ['*'],
                        heights: [50],
                        body: [
                            [contentSection]
                        ]
                    },
                    layout: 'noBorders'
                }
            ],
            pageBreakAfter(currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {
                return false;
            }
        }

        return pdfMake.createPdf(documentDefinition);
    }

    private _renderHeader(dealDetails): any[] {
        const vehicle = dealDetails.vehicle;
        let marketingName =  vehicle.year + ' ' + vehicle.make + ' ' + vehicle.series;
        if(marketingName.length > 40) marketingName = marketingName.substring(0, 40) + '...'
        function marketingNameAndCustomerName(color){
            return [
                {
                    margin: [-32, -10, 10, 30],
                    table: {
                            widths: ['*'],
                            body: [
                                [{ text: marketingName, fontSize: 14, alignment: 'right', color: color, bold: true, margin: [0, 0, 0, 0]}],
                            ]
                        },
                    layout: 'noBorders'
                }
            ]
        };

        if(this.brand === 'Toyota') {
            return [
                {
                    margin: [0, 0, 0, 0],
                    table: {
                        widths: ['8%', '50%', '42%'],
                        body: [
                            [
                                { image: vspecData.VSpecData.LOGO_NO_TEXT.image, width: 32, height: 32, alignment:'left', margin: [0, 0, 0, 0] },
                                this._renderDealerSection(),
                                marketingNameAndCustomerName('#cc0000')
                            ]
                        ]
                    },
                    layout: 'noBorders'
                }
            ];
        } else {
            return [
                {
                    margin: [0, 0, 0, 0],
                    table: {
                        widths: ['28%', '50%', '22%'],
                        body: [
                            [
                                { image: vspecData.VSpecData.LEXUS_LOGO.image, width: 150, height: 20, alignment:'left', margin: [5, 2, 10, 0] },
                                this._renderDealerSection(),
                                marketingNameAndCustomerName('black')
                            ]
                        ]
                    },
                    layout: 'noBorders'
                }
            ];
        }
    
    }

    private getToyotaDealerSection() {
        const phone = this.sharedDataService.dealerPhoneNo;
        return [{
            table: {
                widths: ['*'],
                body: [
                    [
                        {
                            text: `${this.sharedDataService.dealerName || ''}`,
                            bold: true, fontSize: 14, margin:[0,-5,0,0]
                        }
                    ],
                    [
                        {
                            text: `${this.sharedDataService.dealerPostalAddress.lineOne.value || ''} ${this.sharedDataService.dealerPostalAddress.cityName.value || ''} ${this.sharedDataService.dealerPostalAddress.stateOrProvinceCountrySubDivisionID.value || ''} ${this.sharedDataService.dealerPostalAddress.postcode.value} ${phone ? '|': ''} (${(phone || '').slice(0,3)}) ${(phone || '').slice(3,6)}-${(phone || '').slice(6)}`,
                            fontSize: 8, margin:[0,-4,0,0]
                        },
                    ],
                ]}, layout: 'noBorders'
        }];
    }

    private getLexusDealerSection() {
        const phone = this.sharedDataService.dealerPhoneNo;
        return [{
            table: {
                widths: ['*'],
                body: [
                    [
                        {
                            text: `${this.sharedDataService.dealerName || ''}`,
                            bold: true, fontSize: 14, margin:[0,-5,0,0]
                        }
                    ],
                    [
                        {
                            text: `${this.sharedDataService.dealerPostalAddress.lineOne.value || ''} ${this.sharedDataService.dealerPostalAddress.cityName.value || ''} ${this.sharedDataService.dealerPostalAddress.stateOrProvinceCountrySubDivisionID.value || ''} ${this.sharedDataService.dealerPostalAddress.postcode.value} ${phone ? '|': ''} (${(phone || '').slice(0,3)}) ${(phone || '').slice(3,6)}-${(phone || '').slice(6)}`,
                            fontSize: 8, margin:[0,-4,0,0]
                        },
                    ],
                ]
            }, layout: 'noBorders'
        }];
    }

    // Render Dealer Section
    private _renderDealerSection() {        
        if(this.brand === 'Toyota') {
            return this.getToyotaDealerSection();
        } else  {
            return this.getLexusDealerSection();
        }
    }

    renderPaymentSimulationHeader(dealData){
        return [
            {
                table: {
                    margin: [0, -10, 0, 0],
                    dontBreakRows: true,
                    widths: ['*'],
                    body: [    
                        [{ text: [{text:"Payment Simulation",color:'black'}],color: this.grayColor, fontSize: 24, alignment: 'left', margin: [0, 0, 0, 10], border: [false, false, false, false]}],
                        [{ text: [{text: dealData[0].disclaimerText,color:'black'}],color: this.grayColor, fontSize: 10, alignment: 'left', margin: [0, -10, 0, 10], border: [false, false, false, false]}],
                    ]
                }
            }
        ]        
    }

    renderCustomerVehicleDetails(vehicle, customer) {
        return [
            {
                table: {
                    margin: [0, 8, 0, 0],
                    dontBreakRows: true,
                    widths: ['40%', '60%'],
                    body: [    
                        [[this.renderCustomerData(customer)], [this.renderVehicleData(vehicle)]]
                    ]
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return 0;
                    },
                    vLineWidth: function (i, node) {
                        return 0;
                    }
                }
            }
        ] 
    }

    renderCustomerData(customer){
        return [
            {
                table: {
                    margin: [0, 0, 0, 0],
                    dontBreakRows: true,
                    widths: ['*'],
                    body: [    
                        [
                            { text: [{text: `${customer.firstName}, ${customer.lastName}`,color:'black'}],color: this.grayColor,bold: true, fontSize: 14, alignment: 'left', margin: [0, 0, 0, 0 ], border: [false, false, false, false]},
                        ],
                        [
                            { text: [{text: customer.street,color:'black'}],color: this.grayColor, fontSize: 12, alignment: 'left', margin: [0, -3, 0, 0 ], border: [false, false, false, false]},
                        ],
                        [
                            { text: [{text:`${customer.city}, ${customer.state}, ${customer.zipCode}`,color:'black'}],color: this.grayColor, fontSize: 12, alignment: 'left', margin: [0, -4, 0, 0 ], border: [false, false, false, false]},
                        ],
                        [
                            { text: [{text: customer.email,color:'black'}],color: this.grayColor, fontSize: 12, alignment: 'left', margin: [0, -5, 0, 20 ], border: [false, false, false, false]},
                        ],
                    ]
                }
            }
        ];       
    }

    renderVehicleData(vehicle) {
        let marketingName =  vehicle.year + ' ' + vehicle.make + ' ' + vehicle.series;
        return [
            {
                table: {
                    margin: [0, 0, 0, 0],
                    dontBreakRows: true,
                    widths: ['*'],
                    body: [    
                        [
                            { text: [{text:"POTENTIAL VEHICLE",color:'black'}],color: this.grayColor, bold: true, fontSize: 10, alignment: 'left', margin: [0, 0, 0, 0 ], border: [false, false, false, false]},
                        ],
                        [
                            { text: [{text: marketingName,color:'black'}],color: this.grayColor, bold: true, fontSize: 14, alignment: 'left', margin: [0, -3, 0, 0 ], border: [false, false, false, false]},
                        ],
                        [
                            { text: [{text: vehicle.saleClass, color:'black'}],color: this.grayColor, fontSize: 12, alignment: 'left', margin: [0, -4, 0, 0 ], border: [false, false, false, false]},
                        ]
                    ]
                }
            }
        ];
    }

    renderSimulatedFiguresHeading() {
        return [
            {
                table: {
                    margin: [0, 0, 0, 0],
                    dontBreakRows: true,
                    widths: ['*'],
                    body: [    
                        [
                            { text: [{text:"Simulated Figures",color:'black'}],color: this.grayColor, fontSize: 16, alignment: 'left', margin: [0, 10, 0, 0 ], border: [false, true, false, false]},
                        ]
                    ]
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return 1;
                    },
                    vLineWidth: function (i, node) {
                        return 1;
                    },
                    hLineColor: (i, node) => {
                        return '#D8D9DA';
                    },
                    vLineColor: (i, node) => {
                        return '#D8D9DA';
                    }
                }
            }
        ];
    }

    renderSimulatedFigures(dealData) {
        const vehicle = dealData?.vehicle;
        const isCash = !!dealData?.paymentType.includes('cash');
        return [
            {
                table: {
                    margin: [0, 10, 0, 0],
                    dontBreakRows: true,
                    widths: ['15%','17%','15%'],
                    body: !isCash ? [    
                        [
                            { text: [{text: this._formatPrice(vehicle.monthly), color: this.grayColor}],color: this.grayColor, fontSize: 16, alignment: 'center', margin: [0, 0, 0, 0 ], border: [false, false, true, false], borderColor:this.borderColor},
                            { text: [{text: this._formatPrice(vehicle.amountFinanced),color: this.grayColor}],color: this.grayColor, fontSize: 16, alignment: 'center', margin: [0, 0, 0, 0 ], border: [false, false, true, false], borderColor:this.borderColor},
                            { text: [{text: this._formatPrice(vehicle.taxesAndFees),color: this.grayColor}],color: this.grayColor, fontSize: 16, alignment: 'center', margin: [0, 0, 0, 0 ], border: [false, false, false, false], borderColor:this.borderColor},
                        ],
                        [
                            { text: [{text:"MONTHLY",color: this.grayColor}],color: this.grayColor, fontSize: 8, alignment: 'center', margin: [0, 0, 0, 0 ], border: [false, false, true, false], borderColor:this.borderColor},
                            { text: [{text:"AMOUNT FINANCED",color: this.grayColor}],color: this.grayColor, fontSize: 8, alignment: 'center', margin: [0, 0, 0, 0 ], border: [false, false, true, false], borderColor:this.borderColor},
                            { text: [{text:"TAXES & FEES",color: this.grayColor}],color: this.grayColor, fontSize: 8, alignment: 'center', margin: [0, 0, 0, 0 ], border: [false, false, false, false], borderColor:this.borderColor},
                        ]
                    ] : [    
                        [
                            { text: [{text: this._formatPrice(vehicle.amountFinanced),color: this.grayColor}],color: this.grayColor, fontSize: 16, alignment: 'center', margin: [0, 0, 0, 0 ], border: [false, false, true, false], borderColor:this.borderColor},
                            { text: [{text: this._formatPrice(vehicle.taxesAndFees),color: this.grayColor}],color: this.grayColor, fontSize: 16, alignment: 'center', margin: [0, 0, 0, 0 ], border: [false, false, false, false], borderColor:this.borderColor},
                        ],
                        [
                            { text: [{text:"TOTAL ESTIMATED NET AMOUNT DUE",color: this.grayColor}],color: this.grayColor, fontSize: 8, alignment: 'center', margin: [0, 0, 0, 0 ], border: [false, false, true, false], borderColor:this.borderColor},
                            { text: [{text:"TAXES & FEES",color: this.grayColor}],color: this.grayColor, fontSize: 8, alignment: 'center', margin: [0, 0, 0, 0 ], border: [false, false, false, false], borderColor:this.borderColor},
                        ]
                    ]
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return 1;
                    },
                    vLineWidth: function (i, node) {
                        return 1;
                    },
                    hLineColor: (i, node) => {
                        return '#D8D9DA';
                    },
                    vLineColor: (i, node) => {
                        return '#D8D9DA';
                    },
                }
            }
        ];
    }

    renderSpace() {
        return [
            {
                table: {
                    margin: [0, 0, 0, 0],
                    dontBreakRows: true,
                    widths: ['*'],
                    heights: [16],
                    body: [    
                        [
                            { text: [{text: '', color: this.grayColor}],color: this.grayColor, fontSize: 30, alignment: 'center', margin: [0, 0, 0, 0 ], border: [false, false, false, false]},
                        ]
                    ]
                }
            }
        ];
    }

    renderHypoPaymentDetials(vehicle) {
        return [
            {
                table: {
                    margin: [0, 0, 0, 0],
                    dontBreakRows: true,
                    widths: ['15%','15%','15%'],
                    body: [  
                        [
                            { text: [{text:"Hypothetical Payment Details",color: this.grayColor}],color: this.grayColor,colSpan: 3,bold: true, fillColor: this.backgroundColor, fontSize: 12, alignment: 'left', margin: [2, 2, 2, 2]},
                            '',
                            ''
                        ],
                        [
                            { text: [{text:"Cash Down",color: this.grayColor}],color: this.grayColor, bold: true, fontSize: 12, alignment: 'center', margin: [2, 2, 2, 2]},
                            { text: [{text:"Term",color: this.grayColor}],color: this.grayColor, bold: true, fontSize: 12, alignment: 'center', margin: [2, 2, 2, 2]},
                            { text: [{text:"APR",color: this.grayColor}],color: this.grayColor, bold: true, fontSize: 12, alignment: 'center', margin: [2, 2, 2, 2]},
                        ],
                        [
                            { text: [{text: this._formatPrice(vehicle.cashDown),color: this.grayColor}],color: this.grayColor, fontSize: 12, alignment: 'center', margin: [2, 2, 2, 2]},
                            { text: [{text: vehicle.term ? `${vehicle.term} months` :  '', color: this.grayColor}],color: this.grayColor, fontSize: 12, alignment: 'center', margin: [2, 2, 2, 2]},
                            { text: [{text: vehicle.apr ? `${vehicle.apr}%` : '',color: this.grayColor}],color: this.grayColor, fontSize: 12, alignment: 'center', margin: [2, 2, 2, 2]},
                        ]
                    ]
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return 1;
                    },
                    vLineWidth: function (i, node) {
                        return 1;
                    },
                    hLineColor: (i, node) => {
                        return this.borderColor;
                    },
                    vLineColor: (i, node) => {
                        return this.borderColor;
                    },
                }
            }
        ];
    }

    
    renderHypoPricing(dealData) {
        const vehicle = dealData?.vehicle;
        const isCash = !!dealData.paymentType.includes('cash');
        return [
            {
                table: {
                    margin: [0, 0, 0, 0],
                    dontBreakRows: true,
                    widths: ['36%','18%'],
                    body: [  
                        [
                            { text: [{text:"Hypothetical Pricing",color: this.grayColor}],color: this.grayColor, bold: true, fontSize: 12, alignment: 'left', margin: [2, 2, 2, 2], fillColor: this.backgroundColor},
                            { text: [{text:"Total",color: this.grayColor}],color: this.grayColor, bold: true, fontSize: 12, alignment: 'right', margin: [2, 2, 2, 2], fillColor: this.backgroundColor},
                        ],  
                        [
                            { text: [{text:"Vehicle Selling Price",color: this.grayColor}],color: this.grayColor, bold: false, fontSize: 12, alignment: 'left', margin: [2, 2, 2, 2]},
                            { text: [{text: this._formatPrice(vehicle.sellingPrice),color: this.grayColor}],color: this.grayColor, bold: true, fontSize: 12, alignment: 'right', margin: [2, 2, 2, 2]},
                        ],
                        [
                            { text: [{text:"Net Trade-in",color: this.grayColor}],color: this.grayColor, bold: false, fontSize: 12, alignment: 'left', margin: [2, 2, 2, 2]},
                            { text: [{text: this._formatPrice(vehicle.netTrade),color: this.grayColor}],color: this.grayColor, bold: true, fontSize: 12, alignment: 'right', margin: [2, 2, 2, 2]},
                        ],
                        [
                            { text: [{text:"Cash Down",color: this.grayColor}],color: this.grayColor, bold: false, fontSize: 12, alignment: 'left', margin: [2, 2, 2, 2]},
                            { text: [{text: this._formatPrice(vehicle.cashDown),color: this.grayColor}],color: this.grayColor, bold: true, fontSize: 12, alignment: 'right', margin: [2, 2, 2, 2]},
                        ],                        [
                            { text: [{text:"Incentives",color: this.grayColor}],color: this.grayColor, bold: false,fontSize: 12, alignment: 'left', margin: [2, 2, 2, 2]},
                            { text: [{text: this._formatPrice(vehicle.incentives),color: this.grayColor}],color: this.grayColor, bold: true, fontSize: 12, alignment: 'right', margin: [2, 2, 2, 2]},
                        ],
                        [
                            { text: [{text:"Protection Products",color: this.grayColor}],color: this.grayColor, bold: false, fontSize: 12, alignment: 'left', margin: [2, 2, 2, 2]},
                            { text: [{text: this._formatPrice(vehicle.protection),color: this.grayColor}],color: this.grayColor, bold: true, fontSize: 12, alignment: 'right', margin: [2, 2, 2, 2]},
                        ],
                        [
                            { text: [{text:"Add-ons",color: this.grayColor}],color: this.grayColor, bold: false, fontSize: 12, alignment: 'left', margin: [2, 2, 2, 2]},
                            { text: [{text: this._formatPrice(vehicle.addOns),color: this.grayColor}],color: this.grayColor, bold: true, fontSize: 12, alignment: 'right', margin: [2, 2, 2, 2]},
                        ],
                        [
                            { text: [{text: isCash ? "Total Estimated Net Amount Due":"Total Amount Financed",color: this.grayColor}],color: this.grayColor, bold: false, fontSize: 12, alignment: 'left', margin: [2, 2, 2, 2]},
                            { text: [{text: this._formatPrice(vehicle.amountFinanced),color: this.grayColor}],color: this.grayColor, bold: true, fontSize: 12, alignment: 'right', margin: [2, 2, 2, 2]},
                        ]
                    ]
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return 1;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 1) ? 0 : 1;
                    },
                    hLineColor: (i, node) => {
                        return (i === 1) ? 'white' : this.borderColor;
                    },
                    vLineColor: (i, node) => {
                        return this.borderColor;
                    },
                }
            }
        ];
    }

    private _formatPrice(number: any): string {
        const price: string = (number !== 'N/A') ? this._currencyPipe.transform(Number(number), 'USD', 'symbol', '1.2-2') : number;
        return price ? price?.replace('.00', '') : '$0';
    }
}

